import { connect } from 'react-redux';

import TermsConditions from '../components/pages/terms-conditions';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({

});

const TermsConditionsConnector = connect(mapStateToProps, mapDispatchToProps)(TermsConditions);

export default TermsConditionsConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/terms-conditions-connector.js
 **/